import React, {useEffect, useState} from 'react';
import TitleMain from "../../components/Title/TitleMain";
import CardGrid from "../../components/Card/CardGrid";
import CardSimple from "../../components/Card/CardSimple";
import {useUser} from "../../contexts/UserContext";

function SeancesMenuPage() {
    const { user } = useUser();
    const [listCardsData, setlistCardsData] = useState([]);

    useEffect(() => {
        if (user.roles.includes("ROLE_REFERENT") || user.roles.includes("ROLE_USER") || user.roles.includes("ROLE_COACH") || user.roles.includes("ROLE_ADMIN")) {
            let myCards = [
                {
                    titre: "Séances disponibles",
                    image: process.env.REACT_APP_MODE === "dev" ? "/api/illustrations/name/seancesdisponibles.webp" : "/illustrations/name/seancesdisponibles.webp",
                    lien: "/seances/disponibles?sort=date",
                    key: 1
                },
                {
                    titre: "Séances effectuées",
                    image: process.env.REACT_APP_MODE === "dev" ? "/api/illustrations/name/seanceseffectuees.webp" : "/illustrations/name/seanceseffectuees.webp",
                    lien: "/seances/effectuees?sort=dateDesc",
                    key: 2
                }
            ];
            if (!user.roles.includes("ROLE_COACH")) {
                myCards.push({
                    titre: "Séances enregistrées",
                    image: process.env.REACT_APP_MODE === "dev" ? "/api/illustrations/name/seancesenregistrees.webp" : "/illustrations/name/seancesenregistrees.webp",
                    lien: "/seances/enregistrees?sort=date",
                    key: 3
                });
            }

            setlistCardsData(myCards);

        }
    }, [user]);

    return (
        <div className="content">
            <TitleMain text={"Séances"}/>

            <CardGrid cards={listCardsData} CardComponent={CardSimple}/>

        </div>
    )
}

export default SeancesMenuPage;
